module.exports = __webpack_public_path__ + "img/blow-molding.e62c73b5.jpg";